export enum UploadRelationType {
    none = 0,
    Activity = 1,
    Assignment = 2
}